export default function HeroSection() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 64;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-background-50 via-background-50/95 to-background-50 z-10"></div>

      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20soft%20warm%20golden%20and%20deep%20crimson%20lighting%20gradients%2C%20abstract%20film%20texture%20overlay%2C%20subtle%20movie%20reel%20bokeh%20effects%2C%20elegant%20theater%20curtain%20drapes%20in%20shadow%2C%20dramatic%20low%20key%20lighting%2C%20luxurious%20cinema%20aesthetic%2C%20no%20text%2C%20atmospheric%20depth&width=1920&height=1080&seq=hero-bg-cinema&orientation=landscape"
          alt="影视背景氛围"
          className="w-full h-full object-cover opacity-40"
        />
      </div>

      <div className="relative z-20 w-full max-w-7xl mx-auto px-4 md:px-6 py-24 md:py-32">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/25 mb-6">
              <i className="ri-fire-line text-accent-400 text-sm"></i>
              <span className="text-xs font-medium text-accent-400 whitespace-nowrap">全网热播 · 每日更新</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight text-foreground-50">
              91精品影视
              <br />
              <span className="text-primary-400">高清免费在线看片平台</span>
            </h1>

            <p className="mt-6 text-base md:text-lg text-foreground-300 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              91精品影视为您提供海量高清影视资源，覆盖电影、电视剧、动漫、综艺等全品类内容。
              采用高速服务器与智能缓冲技术，确保在线看片不卡顿，画质清晰流畅。
              每日同步更新最新热播资源，无需注册即可免费观看。
            </p>

            <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              本站所有内容完全免费，支持多端同步观看。无论您是追剧达人还是电影爱好者，
              91精品影视都是您贴心的在线看片伙伴。当前站内已收录数万部高清资源，
              覆盖国内外热门题材，全力打造极致的91影视在线看片体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mt-8">
              {[
                { value: '30,000+', label: '高清资源' },
                { value: '每日更新', label: '同步热播' },
                { value: '高清流畅', label: '不卡顿不缓冲' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-400 whitespace-nowrap">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo('#index');
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即观影
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo('#features');
                }}
                className="w-full sm:w-auto px-8 py-3.5 border border-background-300/50 hover:border-primary-400/50 text-foreground-200 hover:text-primary-400 font-medium text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-information-line mr-2"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-64 h-80 sm:w-72 sm:h-96 md:w-80 md:h-[420px] rounded-xl overflow-hidden border border-background-300/30">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20poster%20collage%20style%2C%20dramatic%20film%20noir%20lighting%20with%20warm%20golden%20and%20deep%20crimson%20tones%2C%20abstract%20geometric%20composition%2C%20vintage%20cinema%20texture%2C%20film%20grain%20overlay%2C%20elegant%20silhouette%2C%20luxurious%20dark%20theater%20atmosphere%2C%20sophisticated%20entertainment%20aesthetic%2C%20no%20text&width=640&height=896&seq=hero-poster-visual&orientation=portrait"
                alt="91精品影视 - 高清影视平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 hidden md:block">
        <a
          href="#index"
          onClick={(e) => {
            e.preventDefault();
            scrollTo('#index');
          }}
          className="flex flex-col items-center gap-2 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
        >
          <span className="text-xs whitespace-nowrap">向下探索</span>
          <i className="ri-arrow-down-line animate-bounce text-lg"></i>
        </a>
      </div>
    </section>
  );
}